import React, { PureComponent } from "react"
import styled from "styled-components"
import { FormattedMessage, FormattedHTMLMessage, injectIntl } from "react-intl"
import { compose } from "recompose"
import Box from "../../lib/ui/ui-box"
import Navigation from "../../components/navigation"
import Text from "../../components/text"
import Footer from "../../components/footer"
import WithSizes from "../../hocs/with-sizes.hoc"
import MenuToggle from "../../components/mobile-menu-toggle"
import MobileMenuWrapper from "../../components/mobile-menu-manager/mobile-menu-wrapper.component"

const Header = styled.div`
  width: 100%;
  height: 500px;
  background-image: url(images/backgrounds/BEDROOM.jpg);
  background-size: cover;
  background-position: center center;
`

const Overlay = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  background-color: rgba(44, 43, 89, 0.5);
  align-items: center;
  justify-content: center;
`

class Container extends PureComponent {
  state = {
    isMenuToggled: false
  }

  componentDidMount() {
    window.scrollTo(0, 0)
  }

  toggleMenu = () => this.setState({ isMenuToggled: !this.state.isMenuToggled })

  render() {
    const { isDesktopAndGreater } = this.props
    return (
      <Box flexDirection="column" align="center" py={[4, 4, 12]}>
        <Box
          align="flex-start"
          justify="center"
          w={["80%", "80%", "80%", "1000px"]}
          flexDirection="column"
        >
          <Header>
            <Overlay>
              <Text
                color="white"
                fontFamily="Libre Baskerville"
                fontSize={[5]}
                lineHeight={[5]}
              >
                <FormattedMessage id="about.title" />
              </Text>
            </Overlay>
          </Header>
          {!isDesktopAndGreater && <MenuToggle onClick={this.toggleMenu} />}
          {isDesktopAndGreater && <Navigation {...this.props} />}
          {!isDesktopAndGreater &&
            this.state.isMenuToggled && (
              <MobileMenuWrapper>
                <Navigation {...this.props} />
              </MobileMenuWrapper>
            )}
          <Box
            flexDirection="column"
            w={["80%", "80%", "80%", "1200px"]}
            mt={[5]}
            pb={[2]}
            justify="center"
            align="center"
          >
            <Box flexDirection={["column", "column", "row"]} pt={[4]}>
              <Box pr={[1]} flex={[0.3]}>
                <Text
                  fontSize={[3, 3, 3]}
                  lineHeight={[3, 3, 3]}
                  fontWeight="700"
                  mr={[2]}
                >
                  <FormattedMessage id="about.section1_title" />
                </Text>
              </Box>
              <Box flexDirection="column" pr={[2, 2, 4]} flex={[0.8]}>
                <Text fontSize={[3]} lineHeight={[3]}>
                  <FormattedMessage id="about.section1_p1" />
                </Text>

                <Text mt={[2]} fontSize={[2]}>
                  <FormattedMessage id="about.section1_p2" />
                </Text>

                <Text mt={[0]} fontSize={[2]}>
                  <FormattedHTMLMessage id="about.section1_p3" />
                </Text>
                <Text mt={[2]} fontSize={[2]}>
                  <FormattedHTMLMessage id="about.section1_p4" />
                </Text>
                <Text mt={[2]} fontSize={[2]}>
                  <FormattedHTMLMessage id="about.section1_p5" />
                </Text>
                <Text mt={[2]} fontSize={[2]}>
                  <FormattedHTMLMessage id="about.section1_p6" />
                </Text>

                <Text mt={[2]} fontSize={[2]}>
                  <FormattedHTMLMessage id="about.section1_p7" />
                </Text>
              </Box>
            </Box>

            <Box flexDirection={["column", "column", "row"]} pt={[4]}>
              <Box pr={[1]} flex={[0.3]}>
                <Text
                  fontSize={[3, 3, 3]}
                  lineHeight={[3, 3, 3]}
                  fontWeight="700"
                  mr={[2]}
                >
                  <FormattedHTMLMessage id="about.section2_title" />
                </Text>
              </Box>
              <Box flexDirection="column" pr={[2, 2, 4]} flex={[0.8]}>
                <Text fontSize={[3]} lineHeight={[3]}>
                  <FormattedHTMLMessage id="about.section2_p1" />
                </Text>

                <Text mt={[2]} fontSize={[2]}>
                  <FormattedHTMLMessage id="about.section2_p2" />
                </Text>
              </Box>
            </Box>

            <Box flexDirection={["column", "column", "row"]} pt={[4]}>
              <Box pr={[1]} flex={[0.3]}>
                <Text
                  fontSize={[3, 3, 3]}
                  lineHeight={[3, 3, 3]}
                  fontWeight="700"
                  mr={[2]}
                >
                  <FormattedHTMLMessage id="about.section3_title" />
                </Text>
              </Box>
              <Box flexDirection="column" pr={[2, 2, 4]} flex={[0.8]} pb={[3]}>
                <Text fontSize={[3]} lineHeight={[3]}>
                  <FormattedHTMLMessage id="about.section3_p1" />
                </Text>
                <Text mt={[2]} fontSize={[2]}>
                  <FormattedHTMLMessage id="about.section3_p2" />
                </Text>

                <Text mt={[2]} fontSize={[2]}>
                  <FormattedHTMLMessage id="about.section3_p3" />
                </Text>

                <Text mt={[2]} fontSize={[2]}>
                  <FormattedHTMLMessage id="about.section3_p4" />
                </Text>

                <Text mt={[2]} fontSize={[2]}>
                  <FormattedHTMLMessage id="about.section3_p5" />
                </Text>
              </Box>
            </Box>
          </Box>
        </Box>
        <Footer {...this.props} />
      </Box>
    )
  }
}

export default compose(
  WithSizes,
  injectIntl
)(Container)



// WEBPACK FOOTER //
// ./src/containers/about-us/index.js